var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable } from 'mobx';
import { ApprovalModel } from './ApprovalModel';
import { Candidate } from './CandidateModel';
import { State } from './Enums';
const Default = {
    controlPerson: 'string',
    researcherName: 'string',
    approval: new ApprovalModel().approval,
    creatorId: 0,
    costCenterId: 0,
    customerComment: 'string',
    customerInternalComment: 'string',
    invoiceNumber: 'string',
    receiptNumber: 'string',
    researchStarted: new Date('2018-11-19T15:48:10.485Z'),
    researchCompleted: new Date('2018-11-19T15:48:10.485Z'),
    isRead: false,
    id: 0,
    candidateId: 0,
    candidate: new Candidate(),
    companyId: 0,
    companyName: '',
    servicePackageId: 0,
    state: State.WaitingForConsent,
    reportSummary: '',
    reportSummaryForOrderer: '',
    created: new Date('2018-11-19T15:48:10.485Z'),
    availableFrom: new Date('2018-11-19T15:48:10.485Z'),
    availableTo: new Date('2018-11-19T15:48:10.485Z'),
    deleted: new Date('2018-11-19T15:48:10.485Z'),
    delivered: new Date('2018-11-19T15:48:10.485Z'),
    creatorName: '',
    researcherId: 1,
    checkpointInfo: { checkpointType: '', source: '' },
    orderRecipientUser: [],
    readReceipt: [],
    fileIDs: [],
    groupId: '',
    isInternationalOrder: false,
    partiallyDelivered: '',
    recruitmentProcessDecision: null,
    language: 'Svenska',
    targetCountries: []
};
export class OrderClient {
    constructor(orderClient = Default) {
        this.fromJson(orderClient);
    }
    fromJson(order) {
        this.researcherName = order.researcherName;
        this.approval = new ApprovalModel(order.approval).approval;
        this.id = order.id;
        this.candidateId = order.candidateId;
        this.companyId = order.companyId;
        this.servicePackageId = order.servicePackageId;
        this.state = order.state;
        this.created = new Date(order.created);
        this.availableFrom = new Date(order.availableFrom);
        this.availableTo = new Date(order.availableTo);
        this.deleted = new Date(order.deleted);
        this.delivered = new Date(order.delivered);
        this.orderRecipientUser = order.orderRecipientUser;
        this.readReceipt = order.readReceipt;
        this.isInternationalOrder = order.isInternationalOrder;
        this.partiallyDelivered = order.partiallyDelivered;
        this.recruitmentProcessDecision = order.recruitmentProcessDecision;
        this.language = order.language;
        this.targetCountries = order.targetCountries;
    }
}
__decorate([
    observable
], OrderClient.prototype, "controlPerson", void 0);
__decorate([
    observable
], OrderClient.prototype, "researcherName", void 0);
__decorate([
    observable
], OrderClient.prototype, "approval", void 0);
__decorate([
    observable
], OrderClient.prototype, "creatorId", void 0);
__decorate([
    observable
], OrderClient.prototype, "costCenterId", void 0);
__decorate([
    observable
], OrderClient.prototype, "customerComment", void 0);
__decorate([
    observable
], OrderClient.prototype, "customerInternalComment", void 0);
__decorate([
    observable
], OrderClient.prototype, "invoiceNumber", void 0);
__decorate([
    observable
], OrderClient.prototype, "receiptNumber", void 0);
__decorate([
    observable
], OrderClient.prototype, "researchStarted", void 0);
__decorate([
    observable
], OrderClient.prototype, "researchCompleted", void 0);
__decorate([
    observable
], OrderClient.prototype, "isRead", void 0);
__decorate([
    observable
], OrderClient.prototype, "id", void 0);
__decorate([
    observable
], OrderClient.prototype, "candidateId", void 0);
__decorate([
    observable
], OrderClient.prototype, "companyId", void 0);
__decorate([
    observable
], OrderClient.prototype, "companyName", void 0);
__decorate([
    observable
], OrderClient.prototype, "servicePackageId", void 0);
__decorate([
    observable
], OrderClient.prototype, "state", void 0);
__decorate([
    observable
], OrderClient.prototype, "reportSummary", void 0);
__decorate([
    observable
], OrderClient.prototype, "reportSummaryForOrderer", void 0);
__decorate([
    observable
], OrderClient.prototype, "created", void 0);
__decorate([
    observable
], OrderClient.prototype, "availableFrom", void 0);
__decorate([
    observable
], OrderClient.prototype, "availableTo", void 0);
__decorate([
    observable
], OrderClient.prototype, "deleted", void 0);
__decorate([
    observable
], OrderClient.prototype, "delivered", void 0);
__decorate([
    observable
], OrderClient.prototype, "creatorName", void 0);
__decorate([
    observable
], OrderClient.prototype, "researcherId", void 0);
__decorate([
    observable
], OrderClient.prototype, "checkpointInfo", void 0);
__decorate([
    observable
], OrderClient.prototype, "candidate", void 0);
__decorate([
    observable
], OrderClient.prototype, "orderRecipientUser", void 0);
__decorate([
    observable
], OrderClient.prototype, "readReceipt", void 0);
__decorate([
    observable
], OrderClient.prototype, "fileIDs", void 0);
__decorate([
    observable
], OrderClient.prototype, "groupId", void 0);
__decorate([
    observable
], OrderClient.prototype, "isInternationalOrder", void 0);
__decorate([
    observable
], OrderClient.prototype, "partiallyDelivered", void 0);
__decorate([
    observable
], OrderClient.prototype, "recruitmentProcessDecision", void 0);
__decorate([
    observable
], OrderClient.prototype, "language", void 0);
__decorate([
    observable
], OrderClient.prototype, "targetCountries", void 0);
__decorate([
    action
], OrderClient.prototype, "fromJson", null);
